import { InputSkeleton } from '@/_components';
import {
  CardContainer,
  Container,
  ContainerLayout,
  FormLayout,
  LeftSection,
  RightSection,
  SectionHeadingSkeleton,
  StickyPageHeaderSkeletonWithButtons,
} from '@/_containers';
import PhoneNumberLoading from '@/_containers/inputs/phone-number/loading';

import { HeaderLoading } from './header-loading';

export default function Loading() {
  return (
    <ContainerLayout>
      <StickyPageHeaderSkeletonWithButtons numberOfButtons={2} />

      <Container>
        <LeftSection>
          <HeaderLoading />
          <CardContainer>
            <FormLayout>
              <InputSkeleton className="col-span-12 sm:col-span-6" />
              <InputSkeleton className="col-span-12 sm:col-span-6" />
              <InputSkeleton className="col-span-12 sm:col-span-6" />
              <InputSkeleton className="col-span-12 sm:col-span-6" />
            </FormLayout>
          </CardContainer>

          <CardContainer>
            <SectionHeadingSkeleton />

            <FormLayout>
              <InputSkeleton className="col-span-12 sm:col-span-6" />
              <InputSkeleton className="col-span-12 sm:col-span-6" />
            </FormLayout>
          </CardContainer>
          <CardContainer>
            <SectionHeadingSkeleton withRightSlot />

            <FormLayout>
              <InputSkeleton className="col-span-12 sm:col-span-6" />
            </FormLayout>
          </CardContainer>

          <CardContainer>
            <SectionHeadingSkeleton withRightSlot />

            <FormLayout>
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-3" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-3" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-2" />
              <InputSkeleton className="col-span-12 flex items-end sm:col-span-6 lg:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
              <InputSkeleton className="col-span-12 flex items-end sm:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-4" />
            </FormLayout>
          </CardContainer>

          <CardContainer>
            <SectionHeadingSkeleton withRightSlot />

            <FormLayout>
              <InputSkeleton className="col-span-12 sm:col-span-2" />
              <InputSkeleton className="col-span-12 sm:col-span-3" />
              <InputSkeleton className="col-span-12 sm:col-span-2" />
            </FormLayout>
          </CardContainer>

          <CardContainer>
            <SectionHeadingSkeleton withRightSlot />

            <FormLayout>
              <InputSkeleton className="col-span-12 sm:col-span-6" />
              <InputSkeleton className="col-span-12 sm:col-span-6" />
            </FormLayout>
          </CardContainer>
        </LeftSection>

        <RightSection>
          <CardContainer right>
            <SectionHeadingSkeleton withRightSlot />
            <PhoneNumberLoading />
          </CardContainer>
          <CardContainer right>
            <SectionHeadingSkeleton withRightSlot />
            <PhoneNumberLoading />
          </CardContainer>
        </RightSection>
      </Container>
    </ContainerLayout>
  );
}
